import { DEPENDENT_ROLES } from '../../../constants';
import { IDS } from '../../../constants/ids';

export const roleList = [
  {
    id: IDS.DEPENDENT_ROLES.PARENT,
    role: DEPENDENT_ROLES.PARENT,
    title: 'dependent.form.parentTitle',
    translateId: 'dependent.form.parentInfo',
    isLegal: false,
  },
  {
    id: IDS.DEPENDENT_ROLES.GUARDIAN,
    role: DEPENDENT_ROLES.GUARDIAN,
    title: 'dependent.form.guardianTitle',
    translateId: 'dependent.form.guardianInfo',
    isLegal: true,
  },
  {
    id: IDS.DEPENDENT_ROLES.PROXY,
    role: DEPENDENT_ROLES.PROXY,
    title: 'dependent.form.proxyTitle',
    translateId: 'dependent.form.proxyInfo',
    isLegal: true,
  },
];



// WEBPACK FOOTER //
// ./src/components/DependentForm/utils/roleList.js